import React, { useState } from "react";
import Pagination from "./Pagination";
import CustomTable from "./CustomTable";
import TableSlider from "./TableSlider";
import LoadingPage from "./LoadingPage";

//table structure contiene la estrcutura general de la tabla
//contiene a la tabla, que es customizada
//contiene la paginacion, y los datos de la misma que se recibe como prop
//contiene el slider, que se muestra dependiendo del ancho de la pantalla

//custom table es el contenedor donde se evalua el overflow

const TableStructure = ({
  children,
  paginationProps,
  customMaxWidth,
  showTableLoader,
}) => {
  const { setCurrentPage, currentPage, totalPages, page } =
    paginationProps || {};

  //============SCROLL VARIABLES============
  const [scrollPos, setScrollPos] = useState(0);

  const changeScrollPos = (pos) => {
    setScrollPos(pos);
  };

  const [showScroll, setShowScroll] = useState(false);

  const changeShowScroll = (bool) => {
    setShowScroll(bool);
  };
  //========================================

  return (
    <div className="w-full flex justify-center p-6 flex flex-col items-center relative ">
      {showTableLoader && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <LoadingPage hideText={true} />
        </div>
      )}
      <CustomTable
        scrollPos={scrollPos}
        setShowScroll={changeShowScroll}
        setScrollPos={changeScrollPos}
        customMaxWidth={customMaxWidth}
      >
        {children}
      </CustomTable>
      <div
        className={`flex items-center w-full flex-wrap max-w-[1280px] ${
          !showScroll ? "justify-center" : "justify-around"
        }   relative`}
      >
        {/* {!showScroll && (
          <div
            className={`md:${
              !showScroll ? "hidden" : "flex"
            } hidden max-w-[300px] h-[10px] w-full`}
          ></div>
        )} */}
        {paginationProps && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
            page={page}
          />
        )}

        {showScroll && (
          <div className={`max-w-[300px] w-full ${!paginationProps && "mt-4"}`}>
            <TableSlider scrollPos={scrollPos} setScrollPos={changeScrollPos} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TableStructure;
